// extracted by mini-css-extract-plugin
module.exports = {"gallery":"_X","galleryTitle__info":"_Y","galleryTitle__infoWhite":"_Z","pageLink":"_aa","galleryEntryFour":"_ab","galleryEntry":"_ac"};